import React, { ReactNode } from 'react';
import { ChipColor } from '@app/core';
import { LabeledSection } from './LabeledSection';
import { IconChip } from './IconChip';

interface Props {
  label?: ReactNode;
  color?: ChipColor;
  labelColor?: ChipColor;
  chipIcon?: string;
  chipLabel?: ReactNode;
  iconClassName?: string;
  className?: string;
  variant?: 'plain' | 'std';
}

export const LabeledIconChip: React.FC<Props> = ({
  label,
  labelColor = 'blue',
  chipIcon,
  color = 'inkSecondary',
  chipLabel,
  iconClassName,
  variant = 'std',
  className,
}) => {
  return (
    <LabeledSection label={label} className={className} color={color}>
      <IconChip
        color={labelColor}
        label={chipLabel}
        icon={chipIcon}
        variant={variant}
        iconClassName={iconClassName}
      />
    </LabeledSection>
  );
};
